import React from 'react';
import { Transition } from 'react-transition-group';
const FadeInAnimation = _ref => {
  let {
    show,
    children,
    timeout
  } = _ref;
  const defaultStyle = {
    transition: "opacity ".concat(timeout, "ms ease-in-out"),
    opacity: 0
  };
  const transitionStyles = {
    entering: {
      opacity: 1
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  return /*#__PURE__*/React.createElement(Transition, {
    in: show,
    timeout: timeout,
    unmountOnExit: true
  }, state => /*#__PURE__*/React.createElement("div", {
    style: Object.assign(Object.assign({}, defaultStyle), transitionStyles[state])
  }, children));
};
export { FadeInAnimation };